<div class="row modal-bar">
  <div class="col-sm-6">
      <h5 class="modal-title"><!--{{ passedData.title }}-->Test</h5>
  </div>
  <div class="col-sm-6">
      <div class="modal-actions">
          <div class="modal-close">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
          </div>
      </div>
  </div>
</div>


<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">
      <div class="row mg-b-25">

        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'DIALOGS.EDIT-REPORT-USER-TEMPLATE.FORM.LABEL.SEASON' | translate}}<span class="tx-danger">*</span></label>
            <ng-select [items]="selectableSeasons" bindLabel="Name" bindValue="Id" formControlName="SeasonId" placeholder="{{'DIALOGS.EDIT-REPORT-USER-TEMPLATE.FORM.PLACEHOLDER.SEASON' | translate}}"
                       [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
            <t4-display-validation controlName="SeasonId" [form]="form"></t4-display-validation>
          </div>
        </div>
      </div>


      <div class="form-layout-footer row">
        <div class="col-4">
          <button (click)="download('excel')" [disabled]="formIsInvalid()" class="btn btn-block btn-primary bd-0"><i
            class="far fa-file-excel"></i><span>{{'GENERIC.BUTTON.DOWNLOAD-AS-EXCEL' | translate}}</span></button>
        </div>
        <div class="col-4">
          <button (click)="dialogRef.close(null);" class="btn btn-block btn-secondary bd-0"><i
            class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
        </div>

      </div><!-- form-layout-footer -->
    </div><!-- form-layout -->
  </div>
</form>
